import { atom } from "recoil"

export const applicantIdState = atom<string>({
  key: "atoms/paidTeam/applicantIdState",
  default: undefined,
})
